<div class="advanced-settings">
  <div class="content">

    <div class="content__title">Blocked Users</div>
    <div class="content__box">
      <div *ngFor="let block of blocks" class="d-flex justify-content-between"
        style="font-size: 16px; margin-bottom: 5px">
        <span>{{ block["blocked"]["profileCharacterName"] ?? "User" }}({{ block["timeOfBlock"] | date : "dd/MM/yyyy"
          }})</span>
        <button (click)="unblock(block['blockedId'])"
          style="color: deeppink; background-color: transparent; border: 0px; font-size: 12px">Unblock</button>
      </div>
    </div>

    <div class="content__title">Telegram Chat Bot</div>
    <div class="d-flex justify-content-evenly">
      <div (click)="getTelegramLinks()" class="btn-verified mb-5 mt-2 tg-btn" [class.green]="userInfo?.telegramId">
        <i class="fa-brands fa-telegram icon"></i>
        <div>
          <div class="name">Telegram Account</div>
          <div class="meta">{{ userInfo?.telegramId ? "" : "Not" }} Verified</div>
        </div>
        <i class="fa fa-check-circle" [ngStyle]="{
            color: userInfo?.telegramId ? 'green' : 'red'
          }"></i>
      </div>

      <div (click)="openTelegramPhoneConfirmation()" class="btn-verified mb-5 mt-2 tg-btn"
        [class.green]="userInfo?.isTelegramVerified">
        <i class="fa-brands fa-telegram icon"></i>
        <div>
          <div class="name">Telegram Phone Number</div>
          <div class="meta">{{ userInfo?.isTelegramVerified ? "" : "Not" }} Verified</div>
        </div>
        <i class="fa fa-check-circle" [ngStyle]="{
            color: userInfo?.isTelegramVerified ? 'green' : 'red'
          }"></i>
      </div>
    </div>

    <div class="white_box shadow p-3 d-flex flex-column justify-content-start">
      @if(isBotInfoLoading){
      <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center vh-100">
        <div class="spinner-border text-primary" role="status">
          <span>Loading...</span>
        </div>
      </div>
      }@else if(isBotRegisterationError || !registeredBotToken || isBotBeingEdited){

      <div class="d-flex flex-column justify-content-center mb-6">
        <span>1. Go to <a style="font-weight: bold; color: blue; text-decoration: underline"
            href="https://t.me/BotFather" target="_blank">Bot Father</a></span>
        <span>2. Press the start button on the bot and send <span
            style="background-color: lightblue; font-weight: bold; color: darkblue; font-style: italic">/newbot</span>
          as text message(as you would send anyone) </span>
        <span>3. Give the Bot the name you want and also the username <span
            style="color: purple; font-weight: bold">*Remember you cannot change username after create your bot</span>
        </span>
        <span>4. Copy the token from the bot and send it here</span>
        <span style="font-weight: bold; color: purple">5. After adding token to settings open up your telegram by
          clicking "Open telegram bot from here" to connect bot</span>
      </div>
      <input type="text" [(ngModel)]="candidateBotToken" class="mt-4 p-2" placeholder="Telegram Bot token"
        style="border-radius: 6px" />
      <button class="btn mb-4" (click)="updateTelegramBotRegisteration()"><i class="fa fa-file"></i> Register</button>
      <button (click)="isBotBeingEdited = false" class="btn btn-danger" *ngIf="isBotBeingEdited"><i class="fa fa-x"></i>
        Cancel</button>

      }@else if(registeredBotToken){
      <div class="d-flex flex-column justify-content-evenly">
        <div>
          <span>Username: </span> <span style="color: purple">{{ registeredBotUsername }}</span>
        </div>
        <div>
          <span>Token: </span> <span style="color: purple">{{ registeredBotToken }}</span>
        </div>
        <button (click)="isBotBeingEdited = true; candidateBotToken = registeredBotToken ?? ''" class="btn"><i
            class="fa fa-pen"></i> Change</button>
      </div>
      <div class="mt-3 d-flex flex-column justify-content-evenly">
        @if(isTelegramUserError){
        <div class="d-flex w-100 justify-content-center"><i class="fa-solid fa-triangle-exclamation"></i> Something is
          wrong with your account please make sure you have not blocked the bot or your account is not locked.</div>
        } @if(telegramUserId){
        <div>
          <span>Telegram ID: </span> <span style="color: purple">{{ telegramUserId }}</span>
        </div>
        <div *ngIf="telegramUserFullName">
          <span>Telegram Name: </span> <span style="color: purple">{{ telegramUserFullName }}</span>
        </div>
        <div *ngIf="telegramUsername">
          <span>Telegram Username: </span> <span style="color: purple">{{ telegramUsername }}</span>
        </div>
        <button class="btn" (click)="openRegistration()"><i class="fa fa-pen"></i> Open telegram bot from
          here</button>

        <div class="d-flex w-100 justify-content-center mt-3 align-items-center center"><i
            class="fa-solid fa-triangle-exclamation mr-4"></i>Always make sure you have not blocked or deleted the bot
          and your account is also functional</div>
        }@else{
        <div class="d-flex flex-column justify-content-center mb-6">
          <span>1. Press the button below</span>
          <span>2. Press Start on the bot</span>
        </div>
        <div class="d-flex flex-column mt-3">
          <span style="font-weight: bold"> <i class="fa-solid fa-triangle-exclamation"></i> *Inorder to chat you have
            to register your telegram account</span>
        </div>
        <button class="btn" (click)="openRegistration()"><i class="fa fa-pen"></i> Open telegram bot from
          here</button>

        }
      </div>
      }@else{
      <span>Something went wrong please retry latter</span>
      }
    </div>

    <!-- <div class="btn-verified mt-4" [class.green]="registeredBotToken">
    <i class="fa-brands fa-telegram icon"></i>
    <div>
      <div class="name">Telegram Chat Bot</div>
      <div class="meta">{{ registeredBotToken ? "" : "Not" }} Verified</div>
    </div>
    <i class="fa fa-check-circle" [ngStyle]="{
          color: registeredBotToken ? 'green' : 'red'
        }"></i>
  </div> -->
  </div>
</div>